export default __webpack_public_path__ + "static/media/arrow_forward.f6ed0da0.svg";